import styled from "styled-components";
import LogoGray from "../assets/images/SSD_white_logo.png";
import { Link } from "react-router-dom";
import { forwardRef } from "react";

const FooterContainer = styled.footer`
  width: 100%;
  height: auto;
  padding: 60px 20px;
  background-color: #353535;
  color: #fff;
  /* margin-top: 120px; */
`;

const FooterInner = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
  font-weight: 300;
  max-width: 1120px;
  margin: 0 auto;
`;

const FooterContent = styled.p`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 13px;
  line-height: 20px;
`;

const Divider = styled.span`
  font-weight: 500;
`;

const FooterContentText = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
  font-weight: 300;
`;

const FooterRightContainer = styled.div`
  max-width: 340px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 15px;
  font-size: 13px;

  >div{
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 18px;
  }
`

const FooterLogo = styled.img`
  width: 150px;
`;

const PersonalInformation = styled.div`
  display: flex;
  gap: 10px;
  font-weight: 400;
`

const TitleContent = styled.span`
  font-weight: 500;
`

const AddressContent = styled.span`
`

const TelContent = styled.span`
`

const FooterComponent = forwardRef((props, ref) => {
  const handleTermsClick = () => {
    alert("준비 중인 서비스입니다.")
  }
  return (
    <FooterContainer ref={ref}>
      <FooterInner>
        <FooterContent>
          <FooterContentText>
            <TitleContent>본점 :</TitleContent>
            <AddressContent>
              서울특별시 영등포구 양산로 107, 인곡빌딩 4층, 7층, 9층
            </AddressContent>
            <Divider>|</Divider>
            <TelContent>
              02-2635-8939
            </TelContent>
          </FooterContentText>
          <FooterContentText>
            <TitleContent>구로분실 :</TitleContent>
            <AddressContent>
              서울특별시 구로구 경인로 53길 15, 407호 (구로동, 업무A동)
            </AddressContent>
            <Divider>|</Divider>
            <TelContent>
              02-6679-5500
            </TelContent>
          </FooterContentText>
          <FooterContentText>
            <TitleContent>강남분실 :</TitleContent>
            <AddressContent>
              서울특별시 강남구 테헤란로 38길 29, 6층 (역삼동, 이원빌딩)
            </AddressContent>
            <Divider></Divider>
            <TelContent>
            </TelContent>
          </FooterContentText>
          <FooterContentText>
            <TitleContent>광주지점(분사무소) :</TitleContent>
            <AddressContent>
              광주광역시 서구 상무대로 759,4층(치평동, 지산빌딩)
            </AddressContent>
            <Divider>|</Divider>
            <TelContent>
              062-373-5573
            </TelContent>
          </FooterContentText>
        </FooterContent>
        <FooterRightContainer>
          <div>
            <FooterLogo src={LogoGray} alt="회계법인 새시대" />
            <PersonalInformation>
              <Link onClick={handleTermsClick}>
                이용약관
              </Link>
              <span>
                |
              </span>
              <Link onClick={handleTermsClick}>
                개인정보처리방침
              </Link>
            </PersonalInformation>
          </div>
          <p>
            Copyright © by 회계법인 새시대 All rights reserved.
          </p>
        </FooterRightContainer>
      </FooterInner>
    </FooterContainer>
  );
});

export default FooterComponent;
